import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";
import { getFirestore, type Firestore } from "firebase/firestore";
import { getStorage, type FirebaseStorage } from "firebase/storage";
import { getFirebaseEnv } from "../config";

let app: FirebaseApp | null = null;
let auth: Auth | null = null;
let firestore: Firestore | null = null;
let storage: FirebaseStorage | null = null;

export function getFirebaseServices() {
  const env = getFirebaseEnv();
  if (!env.isConfigured) {
    return null;
  }

  if (!app) {
    app = initializeApp(env.firebaseConfig);
    auth = getAuth(app);
    firestore = getFirestore(app);
    storage = getStorage(app);
  }

  return {
    app,
    auth: auth!,
    firestore: firestore!,
    storage: storage!,
  };
}
